export default __webpack_public_path__ + "static/media/Spotify.f683d8c5.svg";